/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Social_Export_UploadingInputs */

const cs_social_export_uploading = /** @type {(inputs: Social_Export_UploadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nahrávám… ${i?.percent} %`)
};

const en_social_export_uploading = /** @type {(inputs: Social_Export_UploadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading… ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Uploading… {percent}%" |
*
* @param {Social_Export_UploadingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_uploading = /** @type {((inputs: Social_Export_UploadingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_UploadingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_uploading(inputs)
	return cs_social_export_uploading(inputs)
});